import React from 'react';


export default
    <path fillRule="nonzero" d="M19.435.094l1.836 1.77L11 11.764.729 1.864 2.565.094 11 8.224z"/>
